import apiFetch from '../apiFetch'

export default function (token, body) {
  return apiFetch({ endPoint: 'CommissionCancellation/Create', method: 'POST', body: body, token: token })
}
